export default __webpack_public_path__ + "static/media/export.4e2705cc.svg";